export default "__VITE_ASSET__0be1a33d__"